import PropTypes from "prop-types";

const ThreeLevelMessage = ({
  classNameOfContainer,
  classNameOfLevel1,
  textOfLevel1,
  classNameOfLevel2,
  textOfLevel2,
  classNameOfLevel3,
  textOfLevel3,
  level3URL,
  textOfLevel4,
  level4URL,
}) => {
  return (
    <div className={classNameOfContainer}>
      <span className={classNameOfLevel1}>{textOfLevel1}</span>
      <span className={classNameOfLevel2}>{textOfLevel2}</span>
      {!textOfLevel4 ? (
        <a href={level3URL} className={classNameOfLevel3}>
          {textOfLevel3}
        </a>
      ) : (
        <div className="third-level-div">
          <a
            href={level3URL}
            target={"_blank"}
            className={classNameOfLevel3}
            rel="noreferrer"
          >
            {textOfLevel3}
          </a>
          |
          <a
            href={level4URL}
            target={"_blank"}
            className={classNameOfLevel3}
            rel="noreferrer"
          >
            {textOfLevel4}
          </a>
        </div>
      )}
    </div>
  );
};

ThreeLevelMessage.propTypes = {
  classNameOfLevel1: PropTypes.string.isRequired,
  classNameOfLevel2: PropTypes.string.isRequired,
  classNameOfLevel3: PropTypes.string.isRequired,
  level3URL: PropTypes.string.isRequired,
  classNameOfContainer: PropTypes.string.isRequired,
  textOfLevel1: PropTypes.string.isRequired,
  textOfLevel2: PropTypes.string.isRequired,
  textOfLevel3: PropTypes.string.isRequired,
  level4URL: PropTypes.string.isRequired,
  textOfLevel4: PropTypes.string.isRequired,
};

ThreeLevelMessage.defaultProps = {
  classNameOfLevel1: "",
  classNameOfLevel2: "",
  classNameOfLevel3: "",
  level3URL: "",
  classNameOfContainer: "",
  textOfLevel1: "",
  textOfLevel2: "",
  textOfLevel3: "",
  level4URL: "",
  textOfLevel4: "",
};

export default ThreeLevelMessage;
